import { Category } from "../../categories/shared";
import { Serie } from "../../series/shared";

import { Slide } from "../../common/models";

import {
  Award,
  Download,
  Filter,
  Header,
  Highlight,
  Images,
  ImageWithEffects,
  ImageWithHotPoints,
  // PhotoForList,
  GalleryItem,
  Spec,
  Videos,
  Software,
  WhereToBuy
} from "./models";

export class Product {
  _id?: string;
  name: string = "";
  slug: string = "";
  sku: string = "";
  mpn: string = "";
  ean: string = "";
  slogan: string = "";
  description: string = "";
  metaDescription: string = "";
  prominentFeatures: string = "";
  parent: Product;
  category: Category;
  completedLocales: Array<String> = [];
  serie: Serie;
  prominent: boolean = false;
  modelType: "none" | "color" | "cherry" | "options" = "none";
  modelPrimaryColor: string = "";
  modelSecondaryColor: string = "";
  modelOptionName: string = "";
  modelOptionIcon: string = "";
  position: number = 0;
  active: boolean = false;
  discontinued: boolean = false;
  preview: boolean = false;
  published: Date = null;
  created: Date;
  updated: Date;
  images: Images;
  header: Header;
  imageWithHotPoints: ImageWithHotPoints;
  imageWithEffects: ImageWithEffects;
  suggestedInCategories: Array<Category> = [];
  awards: Array<Award> = [];
  downloads: Array<Download> = [];
  filters: Array<Filter> = [];
  slides: Array<Slide> = [];
  highlights: Array<Highlight> = [];
  // photosForList: Array<PhotoForList> = [];
  gallery: Array<GalleryItem> = [];
  specs: Array<Spec> = [];
  videos: Videos;
  software: Software;
  whereToBuy: Array<WhereToBuy> = [];
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/product.model.ts